import script from "./ReceivedReportList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceivedReportList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/received.css?vue&type=style&index=0&id=c7a12a8e&scoped=true&lang=css&external"
import "./ReceivedReportList.vue?vue&type=style&index=1&id=c7a12a8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7a12a8e"]])

export default __exports__